<template>
  <div class="List">
    <ul class="ProductList clearfix">
      <li v-for="(item, index) of items" :key="index">
        <a @click="openDetail(item.pid)" :data-pid="item.pid" :title="item.name">
          <div class="ProductImg img-wrapper">
            <div class="orderIcon" v-if="chkOrder(item.pid) > 0"><span>已選購</span></div>
            <img :src="item.image_url" :alt="item.name" />
          </div>
          <div class="ProductBody">
            <div class="ProductName">{{ item.name }}</div>
            <div class="ProductPrice">
              <span class="Dollor">
                <span class="sym">$</span>
                {{ priceFormat(item.price) }}
              </span>
            </div>
          </div>
        </a>
        <div class="ButtonBar">
          <a @click="openBuyItem(item.pid)" title="立即買" v-if="item.isQuantity > 0" class="Btn">
            選購
          </a>
          <a v-else class="Btn soldout">已售完</a>
        </div>
      </li>
    </ul>

    <productdetail v-if="showDetail" :pid="nowDetailPid" :cid="category" v-on:closeDetail="closeDetail" />
    <buyitem v-if="showBuyItem" v-on:setCartType="setCartType" v-on:addToCart="addToCart"
      v-on:hasAdditional="hasAdditional" :pid="nowDetailPid" v-on:closeBuyItem="closeBuyItem" />
  </div>
</template>

<script>
import productdetail from "./productdetail.vue";
import buyitem from "./buyitem.vue";
export default {
  name: "products",
  data() {
    return {
      cartType: 1,
      showDetail: false,
      nowDetailPid: null,
      nowDetailCid: null,
      showBuyItem: false,
      items: [],
      tempItems: [],
      cids: [],
      filterItems: {},
      isOrder: [],
    };
  },
  props: {
    scrollY: {
      type: Number,
      defaults: 0,
    },
    // 商品資料
    productItems: {
      type: Array,
      defaults: () => []
    },
    // 購物車資料
    shoppingCart: {
      type: Array,
      defaults: () => []
    }
  },
  created() {
    this.parseAPI(this.productItems);
  },
  watch: {
    shoppingCart() {
      this.isInCart();
    },
  },
  computed: {
    chkOrder() {
      return function (p) {
        const order = this.isOrder.find(i => {
          return i == p;
        });
        return order;
      };
    },
  },
  methods: {
    hasAdditional(addInfo, cid) {
      let addInfoBuy = addInfo.additional;
      addInfoBuy = addInfoBuy.filter(
        (item) => item.max_qty > 0
      );
      addInfoBuy.forEach(item => {
        let key = cid.toString() + item.aid.toString(); //$set key值
        this.$set(this.filterItems, key, {
          name: item.name,
          imageurl: item.image_url,
          carttype: 1
        });
      });
      this.$emit('itemall', this.filterItems);
    },
    parseAPI(productData) {
      productData.forEach(item => {
        this.tempItems.push(item.pid);
        this.items.push(item);
        this.filterItems[item.pid.toString()] = {
          name: item.name,
          imageurl: item.image_url,
          carttype: 1
        };
      });
      this.$emit('itemall', this.filterItems);
    },
    isInCart() {
      this.isOrder = [];
      this.shoppingCart.forEach(i => {
        const filterItemsKeyAry = Object.keys(this.filterItems);
        filterItemsKeyAry.forEach(v => {
          if (i.cpid == v) {
            this.isOrder.push(i.pid);
          }
        });
      });
    },
    addToCart(apiPayload) {
      if (this.isAddToCartLoading) {
        return;
      }
      this.isAddToCartLoading = true;

      if (!this.ec.addToCartBeforeCheck(this.cartType, apiPayload)) return;

      fetch(`${this.configs.frontApiPath()}cart/1`, {
        method: 'POST',
        headers: {
          'content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.tools.getCookie('FEEC-FA-TOKEN')
        },
        body: JSON.stringify(apiPayload),
      })
        .then(res => res.json())
        .then(res => {
          this.isAddToCartLoading = false;

          if (res.resultCode === 0) {
            // 加入購物車成功 立即清除導購碼
            document.cookie = `CHANNEL_ID0=;expires=${new Date(0)};path=/;domain=.shopping.friday.tw`;
            // 轉購物車頁
            window.location.href = this.configs.ecDomain() + 'shoppingcart';
            return;
          }

          if (res.resultCode === 1010) {
            window.location.href = this.configs.loginUrl();
            return;
          }

          const message = new this.fridayMessage({
            name: 'add-to-cart',
            type: 'warning',
            message: `商品加入選購清單失敗`,
            className: 'friday'
          });
          message.init();
          message.show();
          this.showBuyItem = false;
        });
    },
    openDetail(pid) {
      // 由popup看detail方式 改轉單頁
      // this.nowDetailPid = pid;
      this.$router.push('/product?pid=' + pid);
    },
    openBuyItem(pid) {
      this.nowDetailPid = pid;
      this.showBuyItem = true;
    },
    closeDetail() {
      this.showDetail = false;
    },
    closeBuyItem() {
      this.showBuyItem = false;
    },
    setCartType(type) {
      this.cartType = type;
    },
    priceFormat(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0;
    },
  },
  components: {
    productdetail,
    buyitem,
  }
};
</script>

<style lang="scss" scoped>
.ProductList {
  li {
    width: 24.25%;
    margin-right: 1%;
    background-color: #fff;
    border-radius: 10px;
    float: left;
    margin-top: 20px;
    transition: .3s;
    cursor: pointer;

    &:nth-child(4n + 4) {
      margin-right: 0;
    }

    &:hover {
      -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
      transform: scale(1.05);
    }
  }

  .ProductImg {
    position: relative;

    .orderIcon {
      width: 100px;
      height: 100px;
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      border-radius: 50%;
      position: absolute;
      top: 68px;
      right: 62px;
      z-index: 1;

      @media(max-width:768px) {
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
      }

      span {
        display: inline-block;
        margin-top: 50px;
        transform: translate(50%, -50%);
      }
    }
  }
}

.ProductName {
  height: 36px;
  overflow: hidden;
  line-height: 1.4;
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .ProductList {
    li {
      margin-bottom: 3%;
      width: 48.5%;
      margin-right: 3%;

      &:nth-child(2n + 2) {
        margin-right: 0
      }
    }
  }
}
</style>
